import React, { useState } from 'react';

const permissions = ['view', 'add', 'edit', 'delete', 'import', 'export', 'share', 'bulk_edit'];

const getColorClass = (perm) => {
  switch (perm) {
    case 'view': return 'success';
    case 'add': return 'info';
    case 'edit': return 'warning';
    case 'delete': return 'danger';
    case 'import': return 'purple';
    case 'export': return 'yellow';
    case 'share': return 'inverse';
    case 'bulk_edit': return 'purple';
    default: return 'default';
  }
};

// Updated Switcher with onChange
const Switcher = ({ menuSlug, perm, checked, onChange }) => (
  <div className={`switcher switcher-${getColorClass(perm)}`}>
    <input
      name={`role[${menuSlug}][${perm}]`}
      id={`role[${menuSlug}][${perm}]`}
      value="1"
      type="checkbox"
      checked={checked}
      onChange={(e) => onChange(menuSlug, perm, e.target.checked)}
    />
    <label htmlFor={`role[${menuSlug}][${perm}]`}></label>
  </div>
);
const RoleMenu = ({ menu, valRoleDetails, updateRoleDetails }) => {
  const menuSlug = menu.role;
  const rolePermissions = (valRoleDetails && valRoleDetails[menuSlug]) || {};
  const [showSubmenu, setShowSubmenu] = useState(false);

  const handlePermissionChange = (slug, perm, value) => {
    updateRoleDetails((prev) => ({
      ...(prev || {}),
      [slug]: {
        ...((prev && prev[slug]) || {}),
        [perm]: value ? "1" : undefined,
      },
    }));
  };

  const renderPermissions = () => {
    return permissions.map((perm) => {
      if (menu.role_type?.includes(perm)) {
        return (
          <Switcher
            key={perm}
            menuSlug={menuSlug}
            perm={perm}
            checked={!!rolePermissions[perm]}
            onChange={handlePermissionChange}
          />
        );
      }
      return null;
    });
  };

  const toggleSubmenu = () => {
    setShowSubmenu((prev) => !prev);
  };

  return (
    <li id={menuSlug}>
      {menu.name}
      {menu.submenu && menu.submenu.length > 0 && (
        <span className="btn btn-xs btn-primary" onClick={toggleSubmenu}>
          Check Fields
        </span>
      )}
      {renderPermissions()}

      {menu.submenu && menu.submenu.length > 0 && (
        <ul
          className="role_ul maintop"
          style={{
            marginTop: 20,
            marginBottom: 20,
            display: showSubmenu ? "block" : "none",
          }}
        >
          <li>
            Fields
            <div className="pull-right">
              {menu.role === "subscriber" && <span>Bulk Edit</span>}
              <span>Edit</span>
              <span>View</span>
            </div>
          </li>
          {menu.submenu.map((sub, idx) => (
            <RoleMenu
              key={sub.role || idx}
              menu={sub}
              valRoleDetails={valRoleDetails}
              updateRoleDetails={updateRoleDetails}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

export default RoleMenu;